import StripeFpxPlugin from './stripe_fpx_plugin';
var bizPluginsList = [StripeFpxPlugin];
export default bizPluginsList;